// components/FormularSesizare/LoadingScreen.jsx

import React from "react";
import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";

// Soft UI Components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

function LoadingScreen({ customColors, message }) {
  return (
    <SoftBox
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="50vh"
      p={3}
    >
      <CircularProgress sx={{ color: customColors.primary.main }} size={60} thickness={2} />
      <SoftTypography
        variant="h6"
        fontWeight="regular"
        color={customColors.secondary.main}
        mt={3}
      >
        {message}
      </SoftTypography>
    </SoftBox>
  );
}

LoadingScreen.propTypes = {
  customColors: PropTypes.shape({
    primary: PropTypes.shape({
      main: PropTypes.string,
    }),
    secondary: PropTypes.shape({
      main: PropTypes.string,
    }),
  }).isRequired,
  message: PropTypes.string,
};

LoadingScreen.defaultProps = {
  message: "Se încarcă formularul...",
};

export default LoadingScreen;
